export enum ClauseType {
  SHARING,
  COMMERCIAL_INFORMATION,
  IMAGE,
  COMBINED,
  PROCESSING,
  NO_SELECTION,
  REGULATIONS,
  USING,
  MARKETING,
  COLLECTING
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/clause-type.enum.ts